import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import V3BudgetBonusRow from './V3BudgetBonusRow';
import FlipMove from 'react-flip-move';
import { useDebouncedPerKeySave } from '../hooks/useDebouncedPerKeySave';

const sortedBudgetBonuses = (budgetBonuses) => {
  return budgetBonuses
    .filter(b => !b._destroy)
    .sort((first, second) => {
      var firstTicketCount = first.ticket_count_requirement
        ? parseFloat(String(first.ticket_count_requirement).replace(/,/g, ''))
        : null;
      var secondTicketCount = second.ticket_count_requirement
        ? parseFloat(String(second.ticket_count_requirement).replace(/,/g, ''))
        : null;

      if (firstTicketCount === null) return 1;
      if (secondTicketCount === null) return -1;
      if (firstTicketCount === secondTicketCount) return 0;
      return firstTicketCount < secondTicketCount ? -1 : 1;
    });
};

const FunctionalV3BudgetBonusRow = forwardRef((props, ref) => (
  <div ref={ref}>
    <V3BudgetBonusRow {...props} />
  </div>
));

const V3BudgetBonusManager = ({
  csrfToken,
  team,
  currentUser,
  budget,
  updateBudget,
  debouncedAutoSaveBudget,
  createBudgetBonus,
  deleteBudgetBonus,
  autoSaveBudgetBonus,
  dealBrackets = [],
  hideAddLink = false
}) => {
  const debouncedAutoSaveBudgetBonus = useDebouncedPerKeySave(autoSaveBudgetBonus);

  return (
    <div>
      <FlipMove enterAnimation="none" leaveAnimation="none">
        {sortedBudgetBonuses(budget.budget_bonuses).map((budgetBonus) =>
          <FunctionalV3BudgetBonusRow key={budgetBonus.id || budgetBonus._key}
                                      csrfToken={csrfToken}
                                      team={team}
                                      currentUser={currentUser}
                                      budget={budget}
                                      budgetBonus={budgetBonus}
                                      deleteBudgetBonus={deleteBudgetBonus}
                                      updateBudget={updateBudget}
                                      debouncedAutoSaveBudgetBonus={debouncedAutoSaveBudgetBonus}
                                      dealBrackets={dealBrackets} />
        )}
      </FlipMove>
      {!hideAddLink && (
        <div style={{
          marginTop: (budget.budget_bonuses || []).filter(b => !b._destroy).length === 0 ? "0px" : "8px",
          marginBottom: "20px"
        }}>
          <a href="#"
             onClick={(e) => {
               e.preventDefault();
               createBudgetBonus();
             }}
             className="text-primary">
            <strong><i className="fal fa-plus"></i> Add Bonus</strong>
          </a>
        </div>
      )}
    </div>
  );
};

V3BudgetBonusManager.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  budget: PropTypes.object.isRequired,
  updateBudget: PropTypes.func.isRequired,
  debouncedAutoSaveBudget: PropTypes.func,
  createBudgetBonus: PropTypes.func.isRequired,
  deleteBudgetBonus: PropTypes.func.isRequired,
  autoSaveBudgetBonus: PropTypes.func.isRequired,
  dealBrackets: PropTypes.array,
  hideAddLink: PropTypes.bool
};

export default V3BudgetBonusManager;
